/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cognito_identity_pool_id": "ca-central-1:d2a4ec61-1fa0-4404-8f7d-b970b6e29abb",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_t2Ug55gqi",
    "aws_user_pools_web_client_id": "6g658l1ea5v6sjmqbcmfct72oe",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "proveracarea342dff5f27b4c6fa2950690cbb70d05db6db-prod",
    "aws_user_files_s3_bucket_region": "ca-central-1"
};


export default awsmobile;
